import React from "react";
import { useLocation } from "react-router";
import { Tabs } from "./Tabs.js";
function RoutingTabs({ tabs, onOpenTab }) {
  const { pathname } = useLocation();
  return /* @__PURE__ */ React.createElement(Tabs, { value: pathname, onChange: onOpenTab, tabs });
}
export {
  RoutingTabs
};
//# sourceMappingURL=RoutingTabs.js.map
